import React from "react";
import {
  formatLocalDateTime,
  getTimezoneAbbreviation,
} from "../../../utils/datetime";
import {
  FiEdit,
  FiTrash2,
  FiCopy,
  FiToggleLeft,
  FiToggleRight,
} from "react-icons/fi";

const GameTableRow = ({
  game,
  onEdit,
  onDuplicate,
  onToggleActive,
  onDelete,
}) => {
  const now = new Date();
  const beforeStart = game.activeFrom && new Date(game.activeFrom) > now;
  const afterEnd = game.activeUntil && new Date(game.activeUntil) < now;
  const effectiveActive = game.isActive && !beforeStart && !afterEnd;
  const statusText = !game.isActive
    ? "Inactive"
    : beforeStart
    ? "Scheduled"
    : afterEnd
    ? "Expired"
    : "Active";

  const getGameUrl = () => {
    try {
      // const hostname = window?.location?.hostname || "";
      const origin = window?.location?.origin || "";
      // const isLocal = /localhost|127\.0\.0\.1/i.test(hostname);
      // const base = isLocal
      //   ? origin
      //   : process.env.REACT_APP_PUBLIC_BASE_URL || origin;
      return `${origin}/${game.id}`;
    } catch (_) {
      return `/${game.id}`;
    }
  };

  const getScheduledTimes = () => {
    const tzAbbrev = getTimezoneAbbreviation();
    return (
      <>
        {game.activeFrom && beforeStart ? (
          <div
            className="status-time"
            title={new Date(game.activeFrom).toString()}
          >
            <span>
              Starts {formatLocalDateTime(game.activeFrom)} {tzAbbrev}
            </span>
            <br />
            <span>
              Ends {formatLocalDateTime(game.activeUntil)} {tzAbbrev}
            </span>
          </div>
        ) : null}
        {game.activeUntil && afterEnd ? (
          <div
            className="status-time"
            title={new Date(game.activeUntil).toString()}
          >
            Ended {formatLocalDateTime(game.activeUntil)} {tzAbbrev}
          </div>
        ) : null}
      </>
    );
  };

  return (
    <tr>
      <td>
        <div className="game-name">{game.name}</div>
      </td>
      <td>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <a
            href={getGameUrl()}
            target="_blank"
            rel="noopener noreferrer"
            title="Open game in new tab"
            style={{ color: "black", textDecorationColor: "#a8a8a8" }}
          >
            <code>/{game.id}</code>
          </a>
        </div>
      </td>
      <td>{(game.type || "connections").toUpperCase()}</td>
      <td>
        <span className={`status ${effectiveActive ? "active" : "inactive"}`}>
          {statusText}
        </span>
        {getScheduledTimes()}
      </td>
      <td>{game.adminNotes || "-"}</td>
      <td>{new Date(game.createdAt).toLocaleDateString()}</td>
      <td>
        <div className="actions">
          <button
            className="btn btn-sm btn-primary"
            onClick={() => onEdit(game)}
          >
            <span title="Edit">
              <FiEdit />
            </span>
          </button>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => onDuplicate(game)}
            title="Duplicate game"
          >
            <span title="Duplicate">
              <FiCopy />
            </span>
          </button>
          <button
            className={`btn btn-sm ${
              game.isActive ? "btn-warning" : "btn-success"
            }`}
            onClick={() => onToggleActive(game)}
          >
            <span title={game.isActive ? "Deactivate" : "Activate"}>
              {game.isActive ? <FiToggleLeft /> : <FiToggleRight />}
            </span>
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => onDelete(game.id)}
          >
            <span title="Delete">
              <FiTrash2 />
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default GameTableRow;
